import React, { lazy, Fragment, Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Global, css } from '@emotion/react';
// import routes from './config/routes';

import { GlobalLoader } from './common/Loaders';
import NotFound from './common/NotFound';
import Page from './pages/Page';
import { ValidateCountry, CountryMapDefault,ValidateWidget} from './routes';

import {config as AppConfig} from './config/appconfig';
import "/home/sac/Projects/template-proj/src/App.css";

// const MapDefaultLazy = lazy(() => import('Mapwrapper'));
// const MapParameterised = lazy(() => import('ValidateState'));

const App = (props) => {
  // const { pathname } = props.location;
  console.log('[App] Path:', useLocation());

  return (
    <Fragment>
      <Global />
      <Suspense fallback={<GlobalLoader />}>
        <Routes>
          {/* <Route path="/quad/:stateName" element={<ValidateState />} />
          <Route path='/afs/state' element={<MapDefault />} /> */}
          {/* <Route path="/bsf/:countryName" element={<ValidateCountry />} /> */}

          <Route path={AppConfig.context.defaultPath} element={<CountryMapDefault />} />
          <Route path="/quadapp/:pattern" element={<ValidateWidget/>}/>

          {/* <Route path='/quadapp' element={<Navigate  to='weather' />} /> */}
          <Route path='*' element={<Navigate  to='quadapp/weather' />} />
        </Routes>
      </Suspense>
    </Fragment>
  );
};

export default App;
